/**
 * Symbol.observable or a string "@@observable". Used for interop
 *
 * @deprecated We will no longer be exporting this symbol in upcoming versions of RxJS.
 * Instead polyfill and use Symbol.observable directly *or* use https://www.npmjs.com/package/symbol-observable
 */
export const observable: string | symbol = (() => (typeof Symbol === 'function' && Symbol.observable) || '@@observable')();
